import { ProductUid, RelatedProductType } from '../../domain/models/related-products.models';

import { ProductPublicModels } from '@features/products/product';

export const florenProductsTransformer = (
    products: ProductPublicModels.PublicApiProduct[],
    productsInfo: ProductUid[]
): ProductPublicModels.PublicApiProduct[] => {
    const transformedProducts = [];
    // biome-ignore lint/complexity/noForEach: <explanation>
    products?.forEach((product) => {
        const relProd = productsInfo?.filter(
            p => p.product_id.toString() === product.id.toString()
        );

        if (relProd && relProd.length !== 0) {
            // biome-ignore lint/complexity/noForEach: <explanation>
            relProd[0].arrColorId.forEach(colorid => {
                // Se filtra que el color venga en los colores del producto
                const color = product?.detail?.colors.filter(
                    c => c.id === colorid
                );
                if (color && color.length !== 0) {
                    // eslint-disable-next-line no-param-reassign
                    product.colorId = colorid;
                    transformedProducts.push({ ...product });
                }
            });
        }
    });
    return transformedProducts;
};

export const recentlyAndCompleteLookTransformer = (
    products: ProductPublicModels.PublicApiProduct[],
    productsInfo: ProductUid[]
): ProductPublicModels.PublicApiProduct[] => {
    return products?.map((apiP) => {
        const relProd = productsInfo?.find(
            p => p.product_id === apiP.id.toString()
        );
        // biome-ignore lint/complexity/noExtraBooleanCast: <explanation>
        if (!!relProd) {
            // eslint-disable-next-line no-param-reassign
            apiP.colorId = relProd.colorId?.split('&')[0];
        }
        return apiP;
    });
};

// PRIVATE
export const transformApiProducts = (
    apiProducts: ProductPublicModels.PublicApiProduct[],
    productsInfo: ProductUid[],
    relatedType: RelatedProductType
): ProductPublicModels.PublicApiProduct[] => {
    // Filter non product objects like "ProductPublicModels.PublicProduct not found" error objects
    const filteredApiProducts = apiProducts.filter((product) => product?.id);

    if (relatedType === 'completeLook' || relatedType === 'recentlyViewed') {
        return recentlyAndCompleteLookTransformer(filteredApiProducts, productsInfo);
    }

    if (relatedType === 'floren') {
        return florenProductsTransformer(filteredApiProducts, productsInfo);
    }
    return filteredApiProducts;
};
